import { useContext, useMemo } from 'react';

import { useSelector } from 'react-redux';

import { INVESTMENT_OFFICES, SYSTEM_ROLES } from 'constants/globals';

import { getInvestmentOfficeId } from 'store/globalApp';
import UserRoleContext from 'context/user-role/context';

import { isDevelopmentEnv as isDevelopmentEnvUtils } from 'utils/access';

import service from 'service/auth';

const useGlobalApp = () => {
  const investmentOfficeId = useSelector(getInvestmentOfficeId);
  const { isSuperAdmin, isSpecialOperations, role, clientId } =
    useContext(UserRoleContext);

  const isSuraOffice = useMemo(
    () => investmentOfficeId === INVESTMENT_OFFICES.SURA,
    [investmentOfficeId],
  );

  const isSmartCapitalOffice = useMemo(
    () => investmentOfficeId === INVESTMENT_OFFICES.SMART_CAPITAL,
    [investmentOfficeId],
  );

  const isDmosOffice = useMemo(
    () => investmentOfficeId === INVESTMENT_OFFICES.DMOS,
    [investmentOfficeId],
  );

  const isDevelopmentEnv = useMemo(() => isDevelopmentEnvUtils(), []);

  return {
    role,
    investmentOfficeId,
    isSuraOffice,
    isSmartCapitalOffice,
    isDmosOffice,
    isSuperAdmin,
    isDevelopmentEnv,
    isSpecialOperations,
    email: String(service.getUsername()),
    clientId,
    isClientRole: role === SYSTEM_ROLES.cliente,
    isSocioRole: role === SYSTEM_ROLES.socio,
  };
};

export default useGlobalApp;
